import qs from 'qs'
import request from '@/utils/request'
request.defaults.baseURL = process.env.VUE_APP_GLY_URL;
// request.defaults.baseURL = "http://localhost:9528";

/**
 * 渠道大区销售占比
 * 
 */
export function areaSaleRate() {
    return request({
      url: '/operation/areaSaleRate',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 本月TOP50商品销量排名
 */
export function goodsRank() {
    return request({
      url: 'operation/goodsRank',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 本月导购销售排名
 */
export function guideRank() {
    return request({
      url: 'operation/guideRank',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 今日销售额等指标
 */
export function indexToday() {
    return request({
      url: 'operation/indexToday',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 会员类型销售占比
 */
export function memberTypeRate() {
    return request({
      url: 'operation/memberTypeRate',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 快产快销
 */
export function produceAndSale() {
    return request({
      url: 'operation/produceAndSale',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 测款预售
 */
export function productTest() {
    return request({
      url: 'operation/productTest',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 近两周拉新趋势
 */
export function registerMemberCount() {
    return request({
      url: 'operation/registerMemberCount',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 月销售达标率
 */
export function saleStandardRate() {
    return request({
      url: 'operation/saleStandardRate',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 近两周销售额趋势
 */
export function salesVolume() {
    return request({
      url: 'operation/salesVolume',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 本月店铺销售排名
 */
export function shopRank() {
    return request({
      url: 'operation/shopRank',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 本月销售总额
 */
export function saleMoney(){
    return request({
        url: 'operation/saleMoney',
        method: 'get',
        data: qs.stringify({})
    })
}

/**
 * 门店分布以及本月各门店销售额
 */
export function storeSale(){
    return request({
        url: 'operation/storeSale',
        method: 'get',
        data: qs.stringify({})
    })
}


/**
 * 大单
 */
export function bigSale(second){
    return request({
        url: '/operation/bigSale?second='+second,
        method: 'get',
        data: qs.stringify({})
    })
}